import {
    ChangeDetectorRef,
    Directive,
    ElementRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { createPopper, Instance, Placement } from '@popperjs/core';
import { BehaviorSubject, EMPTY, fromEvent, merge, Subject } from 'rxjs';
import {
    distinctUntilChanged,
    filter,
    skip,
    switchMap,
    takeUntil,
    tap
} from 'rxjs/operators';

@Directive({
    selector: '[appPopover]'
})
export class PopoverDirective implements OnInit, OnDestroy {
    get config() {
        return this._config;
    }

    @Input() set config(value) {
        this._config = { ...this.config, ...value };
    }
    unsubscribe$ = new Subject();
    private _$isOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    $isOpen = this._$isOpen.asObservable().pipe(distinctUntilChanged());
    get isOpen(): boolean {
        return this._$isOpen.value;
    }

    constructor(public elRef: ElementRef, private _cdr: ChangeDetectorRef) {}

    private _config: {
        placement?: Placement;
        fallbackPlacements?: Array<Placement>;
        multiselect?: boolean;
    } = {
        placement: 'bottom-start',
        multiselect: false
    };
    @HostBinding('class.active') active = false;
    _popperInstance: Instance;
    handleClickEvent(event: Event) {
        // if click inside popover element...
        if (this.elRef.nativeElement.contains(event.target)) {
        } else if (this.isOpen) {
            // else if click outside popover element...
            this._$isOpen.next(false);
        }
    }

    handleKeydownEvent(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.close();
            return;
        }
        /*let next = 0 // Used for home key
    const currentSelection =
      this.options?.find((option) => !!option.selected)?.index || 0
    if (event.key === 'End') {
      // set next to last option
      next = (this.options?.length || 1) - 1
    } else if (event.key === 'ArrowUp') {
      // next can't be less than zero
      next = Math.max(0, currentSelection - 1)

      // prevent container from scrolling
      event.preventDefault()
    } else if (event.key === 'ArrowDown') {
      // next can't be greater than number of options
      next = Math.min((this.options?.length || 1) - 1, currentSelection + 1)

      // prevent container from scrolling
      event.preventDefault()
    }
    // select next option
    this.options?.get(next)?.select(event)*/
    }
    open(target?: ElementRef) {
        this._$isOpen.next(true);
        this.active = true;

        if (target) {
            if (!this._popperInstance) {
                this._popperInstance = createPopper(
                    target.nativeElement,
                    this.elRef.nativeElement,
                    {
                        ...this.config
                    }
                );
            } else {
                this._popperInstance.state.elements.reference = target.nativeElement;
                this._popperInstance.update().then((_) => this._cdr.detectChanges());
            }
        }
    }

    close() {
        this._$isOpen.next(false);
    }

    ngOnInit() {
        this.$isOpen
            .pipe(
                tap((isOpen) => (this.active = isOpen)),
                switchMap((isOpen) =>
                    isOpen
                        ? merge(
                              // listen to click events
                              fromEvent(document, 'click').pipe(
                                  skip(1),
                                  tap((event) => this.handleClickEvent(event))
                              ),
                              // listen to keydown events
                              fromEvent(document, 'keydown').pipe(
                                  // filter keys
                                  filter(
                                      (event) =>
                                          [
                                              'ArrowDown',
                                              'ArrowUp',
                                              'Escape',
                                              'Home',
                                              'End'
                                          ].indexOf((event as KeyboardEvent).key) !== -1
                                  ),
                                  tap((event) =>
                                      this.handleKeydownEvent(event as KeyboardEvent)
                                  )
                              )
                          )
                        : EMPTY
                ),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
        if (this._popperInstance) {
            this._popperInstance.destroy();
            this._popperInstance = null;
        }
    }
}
